import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { showModal } from 'sh-www/utils/modal-controls';

class PostingCloseRoute extends Route {
  @service router;
  @service session;

  @service('commands/assignment-commands')
  assignmentCommandService;

  beforeModel() {
    const { assignId } = this.paramsFor('posting');

    if(!(this.session.currentUser.isBuyer || this.session.currentUser.isAdmin)) {
      this.router.transitionTo('posting', assignId);
    }
  }

  model() {
    const { assignId } = this.paramsFor('posting');

    return this.assignmentCommandService.loadAssignment(assignId, ['buyer']);
  }

  activate(transition) {
    super.activate(...arguments);
    const applicationController = this.controllerFor('application');

    applicationController.setProperties({
      isShowSimpleHeader: true,
      simpleHeaderText: 'Close Posting',
      simpleHeaderRightText: 'Cancel',
      simpleHeaderRightAction: () => {
        const modalModel = {
          actionButtonText: 'Yes, go back',
          cancelButtonText: 'No, continue',
          isShowCancelButton: true,
          titleText: 'Cancel closing posting?',
          bodyText: 'Are you sure you no longer want to close this posting?',
          confirmAction: () => {
            window.history.back();
          }
        };

        showModal(this, 'confirmation', modalModel);
      },
    });

    trackPageViewFromTransition(this, transition, '/posting/:id/close');
  }

  deactivate() {
    const applicationController = this.controllerFor('application');
    applicationController.setProperties({
      isShowSimpleHeader: false,
      simpleHeaderText: '',
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null
    });
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments)
    if (isExiting) {
      controller.closeAssignmentTask.cancelAll();
      controller.resetController();
    }
  }
}

export default PostingCloseRoute;
